import { Link, NavLink, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminPhone");

    navigate("/manage/login", { replace: true });
  };

  return (
    <>
      <div className="sticky-top">
        <div className="container pt-2">
          <div className="navbar navbar-expand-lg py-1 px-1 border-0 shadow-none rounded-pill z-5 my-header-bg">
            <Link to="/">
              <img
                src="/assets/images/icon.png"
                width="48"
                class="me-5 d-lg-block d-none"
              ></img>
            </Link>
            <div className="d-flex align-items-center">
              <button
                class="navbar-toggler collapsed me-2 rounded-circle"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbar-default"
                aria-controls="navbar-default"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="icon-bar top-bar mt-0"></span>
                <span class="icon-bar middle-bar"></span>
                <span class="icon-bar bottom-bar"></span>
              </button>
            </div>
            <div className="ms-auto d-flex align-items-center order-lg-3">
              <div>
                <div className="d-flex align-items-center">
                  <div class="d-flex gap-1 align-items-center justify-content-end me-lg-5 me-2">
                    <a href="https://www.facebook.com/" target="_blank">
                      <img src="/assets/images/facebook.png" width="30" />
                    </a>
                    <img src="/assets/images/instagram.png" width="30" />
                    <a href="https://x.com/" target="_blank">
                      <img src="/assets/images/x.png" width="30" />
                    </a>
                    <a href="https://www.youtube.com/" target="_blank">
                      <img src="/assets/images/youtube.png" width="30" />
                    </a>
                  </div>
                  <div
                    onClick={handleLogout}
                    class="btn btn-icon btn-danger rounded-circle me-1"
                  >
                    <i class="bi bi-power align-middle"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="collapse navbar-collapse" id="navbar-default">
              <ul className="navbar-nav  mt-3 mt-lg-0 ms-lg-2">
                <li className="nav-item">
                  <NavLink to="/manage/dashboard" className="nav-link ps-0">
                    All Users
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/manage/products" className="nav-link">
                    All Products
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/manage/payments" className="nav-link">
                    Payment History
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/manage/wallet-transactions"
                    className="nav-link"
                  >
                    Withdrawal Requests
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/manage/refferal-tree" className="nav-link">
                    Refferal
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/manage/commissions-ledger" className="nav-link">
                    Ledger
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/manage/deliveries" className="nav-link">
                    Deliveries
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
